import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import LoadingIcon from "../../../../components/LoadingIcon";
import { Toast } from "../../../../components/Toast";
import PrimaryButton from "../../../../components/buttons/PrimaryButton";
import SecondaryButton from "../../../../components/buttons/SecondaryButton";
import { JiraConfigureTicketAction } from "../../../../utils/constants";
import JSMConfigureTicket from "./JSMConfigureTicket";
import JiraConfigureTicket from "./JiraConfigureTicket";
import useJiraState from "./useJiraState";

const JiraIssueEditModal = ({
  open,
  onClose,
  initialIssueDetails,
  gapID = null,
}) => {
  const jiraState = useJiraState(initialIssueDetails, gapID);

  const handleEditIssueClick = async () => {
    try {
      let res;
      if (jiraState.isJSM) {
        res = await jiraState.handleJSMEditIncident();
      } else {
        res = await jiraState.handleEditIssue();
      }
      if (res === true) {
        onClose();
      }
    } catch (error) {
      Toast.error("Failed to save Jira issue.");
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      {jiraState.isJSM ? (
        <>
          <DialogTitle>Edit JSM Incident</DialogTitle>
          <DialogContent>
            <JSMConfigureTicket
              jiraState={jiraState}
              action={JiraConfigureTicketAction.EDIT}
            />
          </DialogContent>
        </>
      ) : (
        <>
          <DialogTitle>Edit Jira Issue</DialogTitle>
          <DialogContent>
            <JiraConfigureTicket
              jiraState={jiraState}
              action={JiraConfigureTicketAction.EDIT}
            />
          </DialogContent>
        </>
      )}
      <Box
        sx={{
          justifyContent: "center",
          display: "flex",
          margin: "0 24px 12px",
        }}
      >
        {jiraState.projectsLoading ||
        jiraState.usersLoading ||
        jiraState.issueTypesData?.isLoading ||
        jiraState.customFieldsData?.isLoading ? (
          <LoadingIcon size={25} />
        ) : (
          <DialogActions>
            <SecondaryButton onClick={onClose}>Cancel</SecondaryButton>
            <PrimaryButton onClick={handleEditIssueClick}>Save</PrimaryButton>
          </DialogActions>
        )}
      </Box>
    </Dialog>
  );
};
export default JiraIssueEditModal;
